import { useState, useEffect } from "react";
import { useAuth } from "@/lib/AuthContext";
import { useTheme } from "@/lib/ThemeContext";
import { api } from "@/lib/api";
import logger from "@/lib/logger";
import { Rocket } from "lucide-react";

export default function BetaWelcomeModal() {
  const { user } = useAuth();
  const { tokens: t } = useTheme();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    // Show only once — check localStorage to avoid API delay
    const key = `mmntm_beta_welcome_${user.id}`;
    if (localStorage.getItem(key)) return;
    // Check backend preference
    api.getPreferences().then(prefs => {
      if (!prefs.beta_welcome_seen) setShow(true);
    }).catch(() => {});
  }, [user]);

  const handleDismiss = async () => {
    setShow(false);
    if (user) localStorage.setItem(`mmntm_beta_welcome_${user.id}`, "1");
    try { await api.updatePreferences({ beta_welcome_seen: true }); } catch (e) { logger.warn("BetaWelcomeModal: updatePreferences failed", e); }
  };

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center" data-testid="beta-welcome-modal">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={handleDismiss} />
      <div className="relative w-full max-w-md mx-4 rounded-2xl overflow-hidden shadow-2xl"
        style={{ background: t.bgPrimary, border: `1px solid ${t.borderColor}` }}>
        <div className="px-8 pt-8 pb-2 text-center">
          <div className="w-16 h-16 rounded-2xl mx-auto mb-4 flex items-center justify-center"
            style={{ background: "linear-gradient(135deg, #7C3AED, #4F46E5)" }}>
            <Rocket className="h-8 w-8 text-white" />
          </div>
          <h2 className="text-xl font-bold mb-2" style={{ color: t.textPrimary }}>
            Welcome to the MMNTM Beta
          </h2>
          <p className="text-sm leading-relaxed" style={{ color: t.textMuted }}>
            You're one of the first to try MMNTM. Things may break, features may change,
            and your feedback directly shapes what we build. Use the feedback button
            (bottom-right) anytime to report bugs or request features.
          </p>
        </div>
        <div className="px-8 pb-8 pt-4">
          <button onClick={handleDismiss}
            className="w-full py-3 rounded-xl text-sm font-bold transition-all hover:opacity-90"
            style={{ background: "linear-gradient(135deg, #7C3AED, #4F46E5)", color: "#fff" }}
            data-testid="beta-welcome-dismiss">
            Let's go
          </button>
        </div>
      </div>
    </div>
  );
}
